import React from 'react'
import TextareaAutosize from "react-textarea-autosize";
import { useTranslation } from "react-i18next";
import { fieldAutosizeStyle, resolveFieldDisplaySize } from "../../app/helpers/formFieldDisplayHelper";

const NewTextGeneric = ({ handleChange, values, errors, placeholderVal, field, max_length, moduleText, occupation = 6, css_class}) => {
    const { t } = useTranslation();
    const displaySize = resolveFieldDisplaySize(max_length);

    return (
        <div className={`col-md-${occupation} ${css_class}`}>
            <label htmlFor={field} className="form-label tit-view">
            {t(`${moduleText}.short.${field}`)}
            </label>
            <TextareaAutosize
                cacheMeasurements
                minRows={displaySize.minRows}
                maxRows={displaySize.maxRows}
                style={fieldAutosizeStyle}
                className={`form-control txt-view ${errors[field] && "border border-danger"}`}
                aria-label="empty textarea"
                onChange={(event) => handleChange(event, field)}
                name={field}
                id={field}
                value={values[field] || ""}
                required
                maxLength={max_length}
                placeholder={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
            ></TextareaAutosize>
            {values[field] && (
                <span className="charLeft">
                    {values[field].toString().length}/{max_length} {t("label.characters")}
                </span>
            )}
            {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
        </div>
    )
}

export default NewTextGeneric
